module.exports = __webpack_public_path__ + "img/ionicons.25dc2182.svg";